import { CalendarIcon, LocationIcon, SmileFaceIcon } from "@assets";
import { Box, ListItem, Text, useColorModeValue } from "@chakra-ui/react";
import { NextImage } from "@components/NextImage/NextImage";
import { unique } from "@lib/utils";
import { EventType, NFTEvent, NFTEventInfo } from "@models/event";
import { DEFAULT_LANGUAGE, Language } from "@models/language";

const _t = (key?: string, language = DEFAULT_LANGUAGE) => key || "";

const ListItemWrapper = ({ imgSrc, imgAlt, children }: any) => (
  <ListItem
    display="flex"
    flexDir="row"
    alignItems="center"
    justifyContent="flex-start"
    gap={"0.6rem"}
  >
    <NextImage
      className="w-7 svg-primary flex-shrink-0"
      src={imgSrc}
      alt={imgAlt}
    />
    <Box
      fontWeight={500}
      fontSize="md"
      textAlign="left"
      color={useColorModeValue("", "neutral.10")}
    >
      {children}
    </Box>
  </ListItem>
);

export const EventTime = ({
  event,
  info,
}: {
  event: NFTEvent;
  info: NFTEventInfo;
}) => {
  const datetime =
    info.date || info.time
      ? unique([info.date, info.time]).join(", ")
      : event.duration;
  return (
    <ListItemWrapper imgSrc={CalendarIcon} imgAlt={"calendar icon"}>
      {datetime}
    </ListItemWrapper>
  );
};

export const EventLocation = ({ info }: { info: NFTEventInfo }) => (
  <ListItemWrapper imgSrc={LocationIcon} imgAlt="location-pin icon">
    <>
      {info.locationUrl ? (
        <a href={info.locationUrl} target="_blank" rel="noreferrer">
          <Text as="u" color="primary.300" className="bold underline">
            {info.location}
          </Text>
        </a>
      ) : (
        <Text color={useColorModeValue("", "neutral.10")}>{info.location}</Text>
      )}
    </>
  </ListItemWrapper>
);

export const EventHost = ({
  info,
  language,
  eventType,
}: {
  info: NFTEventInfo;
  language: Language;
  eventType: EventType;
}) => (
  <ListItemWrapper imgSrc={SmileFaceIcon} imgAlt="simle-face icon">
    <Text color={useColorModeValue("", "neutral.10")}>
      {eventType === EventType.MEMBERSHIP
        ? _t("Created by ", language)
        : _t("Hosted by ", language)}
      {info.organizer.url ? (
        <a href={info.organizer.url} target="_blank" rel="noreferrer">
          <span className="text-primary-300 underline font-medium">
            {info.organizer.name}
          </span>
        </a>
      ) : (
        info.organizer.name
      )}
    </Text>
  </ListItemWrapper>
);
